var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMySavedItemsBig = function SvgMySavedItemsBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#my-saved-items-big_svg__clip0_1683_167864)",
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.72 5.708a11.162 11.162 0 00-7.916-3.28c-2.865 0-5.73 1.094-7.916 3.28L20 6.572l-.887-.864a11.162 11.162 0 00-7.917-3.28c-2.865 0-5.731 1.094-7.917 3.28-4.372 4.372-4.372 11.46 0 15.833l15.543 15.543a1.66 1.66 0 001.178.488c.427 0 .853-.163 1.178-.488L36.721 21.54c4.372-4.372 4.372-11.46 0-15.833zm-1.178 14.655L20 35.905 4.458 20.363a9.466 9.466 0 01-2.791-6.739c0-2.545.99-4.938 2.79-6.738a9.466 9.466 0 016.739-2.79 9.48 9.48 0 016.754 2.806L20 8.898l2.066-2.012a9.466 9.466 0 016.738-2.79c2.545 0 4.939.99 6.738 2.79a9.466 9.466 0 012.791 6.738c0 2.546-.99 4.939-2.79 6.739z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.462 6.119a.659.659 0 01-.927-.003l-.152.42.555.202.347-.179.177-.44z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "my-saved-items-big_svg__clip0_1683_167864"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgMySavedItemsBig;